import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { AgreementIntegrationConfig } from "@modules/erpIntegrations/types";
import { getErpErrorMessage } from "@modules/erpIntegrations/utils";

import { editConfigService } from "./service";
import { ConfigPatchPayload, UseEditConfigMutationOptions } from "./types";

export function useEditConfigMutation(options?: UseEditConfigMutationOptions) {
  const { open } = useNotification();

  return useMutation<
    AgreementIntegrationConfig,
    ApiError,
    { id: string; data: ConfigPatchPayload }
  >({
    mutationFn: ({ id, data }) => editConfigService(id, data),
    ...options,
    onError: (error, variables, context) => {
      open?.({
        type: "error",
        message: getErpErrorMessage(error),
      });
      options?.onError?.(error, variables, context);
    },
  });
}
